import React, { useEffect, useRef, useState, useCallback } from "react";
import "./Header.css";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Select from "react-select";
import { FiSearch } from "react-icons/fi";

const backend = await new Backend().init();

export default function Header({
  type,
  supers: onSuperChange,
  updateType,
  userType,
}) {
  const selectRef = useRef();

  const [supers, setSupers] = useState([]);
  const [filteredSupers, setFilteredSupers] = useState([]);
  const [selectedSuper, setSelectedSuper] = useState(null);
  const [loading, setLoading] = useState(false);

  /** 🧠 Load Supers */
  const loadSuperFilter = useCallback(async () => {
    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        admin_id: localStorage.getItem("id"),
      };

      const response = await backend.user_filter(data);

      if (response.error === "False") {
        const mapped = response.user.map((u) => ({
          label: u.username,
          value: JSON.stringify(u),
          raw: u,
        }));

        setSupers(mapped);
        setFilteredSupers(mapped);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      toast.error("Failed to load super list.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSuperFilter();
  }, [loadSuperFilter]);

  /** 🔍 Search */
  const handleSearch = (query) => {
    if (!query) return setFilteredSupers(supers);

    const filtered = supers.filter((x) =>
      x.raw.username.toLowerCase().includes(query.toLowerCase())
    );

    setFilteredSupers(filtered);
  };

  /** 🧩 Select */
  const handleChange = (option) => {
    if (!option) return;

    const selected = JSON.parse(option.value);
    setSelectedSuper(selected);
    onSuperChange(selected.super_id);
  };

  /** 🧹 Clear */
  const handleClear = () => {
    setSelectedSuper(null);
    onSuperChange(null);
  };

  return (
    <div className="h-[55px] bg-[var(--background)] items-center flex pr-4 pl-4">
      {/* LEFT SIDE BUTTONS */}
      <div className="UserLeft">
        <button
          onClick={() => updateType(1)}
          className={`NavLinkBtn hover marginright ${
            type === 1 ? "selectlink" : "unselectlink"
          }`}
        >
          SUMMARY MASTER
        </button>

        <button
          onClick={() => updateType(2)}
          className={`NavLinkBtn hover marginright ${
            type === 2 ? "selectlink" : "unselectlink"
          }`}
        >
          MASTER
        </button>
      </div>

      {/* RIGHT SIDE */}
      <div className="UserRight">
        {userType === 1 && (
          <>
            {selectedSuper ? (
              <button className="NavLinkBtn hover marginright unselectlink">
                SUPER: {selectedSuper.username}
              </button>
            ) : (
              <div className="relative w-[240px]">
                {/* USER ICON */}

                <FiSearch
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-[18px] z-10"
                  style={{ color: "var(--text)" }}
                />

                <Select
                  ref={selectRef}
                  placeholder={loading ? "Loading supers..." : "Select Super"}
                  options={filteredSupers}
                  value={null}
                  isSearchable
                  onInputChange={handleSearch}
                  onChange={handleChange}
                  classNamePrefix="rs"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "20px",
                      paddingLeft: "28px",
                      border: "none",
                      minHeight: "36px",
                      backgroundColor: "var(--hover)", // ← bg theme
                      boxShadow: "none",
                      color: "var(--text)",
                    }),

                    placeholder: (base) => ({
                      ...base,
                      color: "var(--text)",
                      opacity: 0.6,
                    }),
                    menu: (base) => ({
                      ...base,
                      backgroundColor: "var(--background)",
                      overflow: "hidden",
                      borderRadius: "12px",
                      border: "2px solid var(--hover)", // <— your border
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // <— card shadow
                      marginTop: "6px",
                      padding: "4px",
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      backgroundColor: isFocused
                        ? "var(--primary)"
                        : "transparent",
                      color: isFocused ? "#fff" : "var(--text)",
                      cursor: "pointer",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "var(--text)",
                    }),
                    input: (base) => ({
                      ...base,
                      color: "var(--text)",
                    }),
                  }}
                />
              </div>
            )}

            {/* ACTION BUTTONS */}
            {selectedSuper && (
              <div>
                <button
                  onClick={() => updateType(0)}
                  className="NavLinkBtn hover marginright unselectlink"
                >
                  CREATE MASTER
                </button>

                <button
                  onClick={handleClear}
                  className="dropbtnNavSub sell marginright white"
                >
                  CLEAR
                </button>
              </div>
            )}
          </>
        )}

        {userType === 2 && (
          <button
            onClick={() => updateType(0)}
            className="NavLinkBtn hover marginright unselectlink"
          >
            CREATE MASTER
          </button>
        )}
      </div>
    </div>
  );
}
